webpackJsonp([107818501498521],{

/***/ 207:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	exports.default = Template;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(39);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// import '../css/blog-post.css';
	
	function Template(_ref) {
	  var data = _ref.data;
	  var post = data.markdownRemark;
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'blog-post-container' },
	    _react2.default.createElement(_reactHelmet2.default, { title: post.frontmatter.title + ' - My Awesome Site' }),
	    _react2.default.createElement(
	      'div',
	      { className: 'blog-post' },
	      _react2.default.createElement(
	        'div',
	        { className: 'breadcrumbs' },
	        _react2.default.createElement(
	          'a',
	          { href: '/' },
	          'Home'
	        ),
	        ' ',
	        _react2.default.createElement(
	          'a',
	          { href: '/blog/' },
	          'Blog'
	        ),
	        ' ',
	        _react2.default.createElement(
	          'span',
	          null,
	          post.frontmatter.title
	        )
	      ),
	      _react2.default.createElement('img', { src: post.frontmatter.image, alt: post.frontmatter.title }),
	      _react2.default.createElement(
	        'h1',
	        null,
	        post.frontmatter.title
	      ),
	      _react2.default.createElement('div', { className: 'blog-post-content', dangerouslySetInnerHTML: { __html: post.html } })
	    )
	  );
	}
	
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-blog-post-js-24c0a3a6cf1f197481d5.js